import React, { useEffect, useState, useMemo } from "react";
import "../style/page/speciality.scss";
import BasicTable from "../maincomponent/reacttable/table";
import axios from "axios";
import {
  spacilitylist,
  updatespeciality,
  specialitydelete,
  specialitiesexcel,
} from "../../text/apidata";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  speciality,
  specialityid,
  sidebar,
} from "../redux/reducer/counterslice";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import SpecialityForm from "../form/specialityform";
import Swal from "sweetalert2";

function Speciality(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const symid = useDispatch();
  const [datacount, setdatacount] = useState();
  const specialityedit = useSelector((state) => state.counter.speciality);
  let roledata = localStorage.getItem("role");
  const [isactivefilterdata, setisactivefilterdata] = useState("");
  const [popup, setpopup] = useState(false);
  const [id, setid] = useState();
  const [sno, setsno] = useState(0);

  const dropdownhandlechange = (e) => {
    // setAge(e.target.value)

    if (e) {
      //   specialitynav("/SpecialityForm");
      dispatch(speciality("specialityedit"));
      symid(specialityid(e));
    }
  };

  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        props.loaderchange("true");
        axios({
          method: "get",
          url: spacilitylist,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: searchQuery ? "1" : dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            is_active: isactivefilterdata,
          },
        })
          .then((res) => {
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data);
            props.loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
            props.loaderchange("false");
            // setdtPageindex(dtpageindex-1)
            console.log(dtpageindex);
            props.popupalert("true");
            props.popuptext("No Data Available");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          });
      }
    } else {
      props.loaderchange("true");
      axios({
        method: "get",
        url: spacilitylist,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: searchQuery ? "1" : dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          is_active: isactivefilterdata,
        },
      })
        .then((res) => {
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data);
          props.loaderchange("false");
        })
        .catch((error) => {
          console.log(error);
          props.loaderchange("false");
          // setdtPageindex(dtpageindex-1)
          console.log(dtpageindex);
          props.popupalert("true");
          props.popuptext("No Data Available");
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
        });
    }
  }, [
    dtpageindex,
    dtpagesize,
    searchQuery,
    specialityedit,
    isactivefilterdata,
  ]);

  const deletespeciality = (e) => {
    setid(e);
    setpopup(true);
  };
  const columns = useMemo(
    () => [
      {
        Header: "S.NO",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row,"find slno");
          // console.log(sno);
          return <p>{row.row.original.slno}</p>;
        },
      },
      {
        Header: "Speciality",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="speciality"
                  data-tooltip-content={String(row.row.original.name)}
                >
                  {String(row.row.original.name)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Description",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="speciality"
                  data-tooltip-content={`${row.row.original.description}`}
                >
                  {row.row.original.description &&
                    row.row.original.description.length > 20
                    ? `${row.row.original.description.substring(0, 25)}...`
                    : `${row.row.original.description}`}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Active",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.is_active == false ? "No" : "Yes"
                }
              >
                {row.row.original.is_active == false ? (
                  <p style={{ color: "red", fontWeight: 700 }}>No</p>
                ) : (
                  <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                )}
              </p>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original)
          //settablevalue(row.row.original)

          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm delete"
                  onClick={(e) => deletespeciality(row.row.original.id, e)}
                >
                  <i class="bi bi-trash3"></i> Delete
                </button>
              </div>
            </>
          );
        },
      },
    ],
    [sno]
  );

  const creatfunction = (e) => {
    // specialitynav("/SpecialityForm");
    dispatch(speciality("create"));
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };
  const getdata = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want to Update Data ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "get",
          url: updatespeciality,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Data Has Been Upadated",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch((error) => { });
      }
    });
  };
  const confirm = () => {
    props.loaderchange("true");
    axios({
      method: "delete",
      url: specialitydelete + id + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then((res) => {
        console.log(res.data);
        // window.location.href = "/Banner";
        setpopup(false);
        window.location.reload();

        props.loaderchange("false");

        props.popupalert("true");
        props.popuptext("Data Deleted Successfully");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
        // setdtPageindex(dtpageindex-1)
        // console.log(dtpageindex)
      });
  };
  const datadownload = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want To Download The Data?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "get",
          url: specialitiesexcel,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            window.open(res.data.data, "_self");
            // Swal.fire(
            //   'Deleted!',
            //   'Your file has been deleted.',
            //   'success'
            // )

            console.log(res);
          })
          .catch((err) => { });
      }
    });
  };
  return (
    <>
      <div
        className={sideactive ? "maincontainer_spe-sa" : "maincontainer_spe"}
      >
        <div className="patient-header ">
          <div className="row">
            <div className="col">
              <h3 className="page-title">Speciality</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a
                    href="/"
                    style={{ textDecoration: "none", color: "black" }}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </a>
                </li>
                <li className="breadcrumb-item active">Speciality</li>
              </ul>
            </div>
            <div class="col-sm-5 col">
              <a
                onClick={(e) => creatfunction(e)}
                style={{
                  backgroundColor: "#1b5a90",
                  border: "1px solid #1b5a90",
                  color: "white",
                }}
                data-toggle="modal"
                class="btn btn-primary float-right mt-2"
              >
                Add
              </a>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="speciality">
                  <div className="table-content-speciality">
                    <form
                      onSubmit={handleSubmit}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        class="input-group rounded"
                        style={{ width: "250px", height: "40px" }}
                      >
                        <input
                          type="search"
                          class="form-control rounded"
                          aria-label="Search"
                          aria-describedby="search-addon"
                          value={searchQuery}
                          onKeyDown={(e) => {
                            if (e.target.value.length === 0 && e.which === 32) {
                              e.preventDefault();
                            }
                          }}
                          onInput={(e) => {
                            if (e.target.value.length <= "100") {
                              setSearchQuery(e.target.value);
                            } else {
                              e.preventDefault();
                            }
                          }}
                          // onKeyDown={(e)=>{if(e.which=="32"){
                          //   e.preventDefault()
                          // }}}

                          min="0"
                          max="10"
                          label="Search"
                          placeholder="Search..."
                          required
                        />
                        <span
                          class="input-group-text border-0 bg-transparent"
                          id="search-addon"
                        >
                          <i
                            class="bi bi-search"
                            style={{
                              color: "#1b5a90",
                              width: "20px",
                              height: "20px",
                            }}
                          ></i>
                        </span>
                      </div>
                      <div>
                        <>
                          {/* <button
                            className="getdata"
                            onClick={(e) => {
                              getdata();
                            }}
                          >
                            <div class="spinner">
                              <i class="bi bi-chevron-double-down"></i>
                            </div>
                            Update Speciality Data
                          </button> */}

                          <div
                            align="center"
                            type="button"

                          >
                            <a class="dnbtn" onClick={(e) => {
                              datadownload();
                            }}></a>
                          </div>
                        </>
                      </div>
                    </form>

                    <div className="table-speciality">
                      <BasicTable
                        columns={columns}
                        data={tableheaderdata}
                        pagesize={pagesize}
                        pageindex={pageindex}
                        dtpagesize={dtpagesize}
                        dtpageindex={dtpageindex}
                        datacount={datacount}
                        isactive={true}
                        isactivefilterdata={isactivefilterdata}
                        setisactivefilterdata={setisactivefilterdata}
                        // setsno={setsno}
                        // sno={sno}
                        id={"spe"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ReactTooltip
          id="speciality"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {specialityedit == "specialityedit" || specialityedit == "create" ? (
        <SpecialityForm
          loaderchange={loaderchangechild}
          popupalert={popupalertchild}
          popuptext={popuptextchild}
        />
      ) : (
        ""
      )}
      {popup && (
        <>
          <div className="logout_popup">
            <div class="container1">
              <div class="cookiesContent" id="cookiesPopup">
                <button
                  class="close"
                  onClick={(e) => {
                    setpopup(false);
                  }}
                >
                  ✖
                </button>
                {/* <img src={logoutimg} alt="cookies-img" /> */}
                <p style={{ marginTop: "20px" }}>
                  Do You Want to Delete the Data?
                </p>
                <div style={{ display: "flex" }}>
                  <button class="accept p-2 m-2" onClick={(e) => confirm()}>
                    Yes!
                  </button>
                  <button
                    class="accept p-2 m-2"
                    onClick={(e) => setpopup(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Speciality;
